import { gql } from '@/shared/graphql/generated/explorer';

export const getBurnInfoQuery = gql(/* GraphQL */ `
  query GetBurnInfo($maxTimestamp: Datetime!) {
    historicalBurn: allBurns(filter: { timestamp: { lessThanOrEqualTo: $maxTimestamp } }) {
      aggregates {
        sum {
          totalAmount
        }
      }
    }
    currentBurn: allBurns {
      aggregates {
        sum {
          totalAmount
        }
      }
    }
  }
`);
